import { Navigate, RouteObject } from "react-router";
import { ReportsIndexRoute } from "@/routes/processes/[processId]/htz/reports/_components/reports-index-route";
import { ReportRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/report-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/data/data-route";
import { PhotosRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/photos/photos-route";
import { VisualRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/visual/visual-route";
import { StructuralRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/structural/structural-route";
import { MicrobialRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/microbial/microbial-route";
import { ItemsRoute } from "@/routes/processes/[processId]/htz/reports/[reportId]/items/items-route";

export const htzReportsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ReportsIndexRoute />,
  },
  {
    path: ":reportId",
    element: <ReportRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "items",
        element: <ItemsRoute />,
      },
      {
        path: "microbial",
        element: <MicrobialRoute />,
      },
      {
        path: "structural",
        element: <StructuralRoute />,
      },
      {
        path: "visual",
        element: <VisualRoute />,
      },
      {
        path: "photos",
        element: <PhotosRoute />,
      },
    ],
  },
];
